import * as React from 'react';
import ouiDom from '@goldwasserexchange/oui-dom';
import { TopModel } from '@goldwasserexchange/react-topmodel';
import ouiStyle from '@goldwasserexchange/oui-style';
import {
  ArticleLine,
  ArticleReleaseDateAndShareContent,
  NewsArticleTitleContent,
  ArticleBodyContent,
  ArticleImage,
  ArticleDisclaimer,
} from './components';
import { ArticleReleaseDateAndShareContainer } from './components/releaseDateAndShare/components/container';

export const ArticleContent = () => (
  <ouiDom.HeadingSection.HeadingSection
    name="Article"
    index={0}
    illustrationPosition="after"
    paddingRight={0}
    paddingLeft={[0, undefined, undefined, 4, undefined, undefined]}
    paddingBottom={[1, undefined, undefined, 6, undefined, undefined]}
    widthLines="full"
  >
    <TopModel
      name="HeadingSectionTitleContainer-Article"
      color={ouiStyle.Constants.Colors.accent}
      lineFactor={[2, undefined, undefined, 2.7, undefined, undefined]}
    >
      {ouiDom.HeadingSection.DomH1}
    </TopModel>
    <TopModel
      name="HeadingSectionTitleContent-Article"
    >
      {NewsArticleTitleContent}
    </TopModel>
    <TopModel
      name="HeadingSectionIllustrationContainer-Article"
      paddingTop={['simple', undefined, undefined, 'none', undefined, undefined]}
    >
      {ouiDom.HeadingSection.DomIllustrationContainer}
    </TopModel>
    <TopModel
      name="HeadingSectionIllustrationContent-Article"
    >
      {ArticleImage}
    </TopModel>
    <TopModel
      name="HeadingSectionIntroContainer-Article"
      color={ouiStyle.Constants.Colors.primary}
    >
      {ArticleReleaseDateAndShareContainer}
    </TopModel>
    <TopModel
      name="HeadingSectionIntroContent-Article"
    >
      {ArticleReleaseDateAndShareContent}
    </TopModel>
    <ArticleBodyContent />
    <ArticleLine />
    <ArticleDisclaimer />
  </ouiDom.HeadingSection.HeadingSection>
);
